export const soporteRoutes = [
  {
    path: '/soporte',
    name: 'SoporteIndex',
    component: () =>
      import(
        /* webpackChunkName: "soporte" */ '@/modules/Soporte/views/SoporteIndex.vue'
      ),
    icon: 'mdiLifebuoy',
    typeIcon: 'mdi',
    menu: true,
    desplegable: false,
    meta: {
      title: 'Soporte',
      requiresSession: true,
      permiso: [],
      perfiles: [],
      showBackButton: false
    },
    children: []
  },
  {
    path: '/soporte/:id',
    name: 'SoporteDetalle',
    component: () =>
      import(
        /* webpackChunkName: "soporte" */ '@/modules/Soporte/views/SoporteView.vue'
      ),
    icon: '',
    menu: false,
    desplegable: false,
    meta: {
      title: 'Ticket de soporte',
      requiresSession: true,
      permiso: [],
      perfiles: [],
      showBackButton: true
    },
    children: []
  }
]
